import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=05dd4b03&scoped=true&"
import script from "./Content.vue?vue&type=script&lang=js&"
export * from "./Content.vue?vue&type=script&lang=js&"
import style0 from "./Content.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Content.vue?vue&type=style&index=1&id=05dd4b03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05dd4b03",
  null
  
)

export default component.exports